<template>
  <div>

    <BreadCrumbs 
      :children="[
        {
          text: `Usuarios del Admin (${users.length})`,
        }
      ]"/>

    <div class="row ml-1">
      <div class="col-sm-12 text-left">
        <button class="btn mr-1 main-bg" @click="openModal" v-if="$userIsAdmin()">
          <i class="fa fa-plus"></i>
          Crear Usuario
        </button>
      </div>
    </div>

    <div class="card ml-15">
      <div class="card-body">

        <div v-if="loading" class="text-center">
          <Loader />
        </div>
        <div v-else class="table-wraper">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th>Nombre</th>
                <th>Correo</th>
                <th>Rol</th>
                <th>Sucursales</th>
                <th class="text-center">Opciones</th>
              </tr>  
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td>{{ user.name }}</td>
                <td>{{ user.id }}</td>
                <td>
                  <div class="" v-if="user.role === $constants.userRoles.ADMIN">
                    Administrador
                  </div>
                  <div class="" v-else-if="user.role === $constants.userRoles.COMERCE">
                    Supervisor
                  </div>
                  <div class="" v-if="user.role === $constants.userRoles.DELIVERY">
                    Repartidor
                  </div>
                </td>
                <td>
                  {{ user.role !== $constants.userRoles.ADMIN ? user.company : '' }}
                </td>
                <td class="text-center">
                  <span v-if="user.loading">
                    <i class="fa fa-spinner fa-spin"></i>
                  </span>
                  <span v-else>
                    <a
                      title="Eliminar usuario"
                      @click="deleteUser(user)"
                      href="#"
                      class="text-danger mr-3"
                    >
                      <i v-if="user.loading" class="fa fa-spinner fa-spin fa-2x"></i>
                      <i v-else class="fa fa-trash fa-2x"></i>
                    </a>
                    <a
                      title="Cambiar clave"
                      @click="openPasswordChangeModal(user)"
                      href="#"
                      class="badge badge-primary"
                    >Cambiar clave</a>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <!-- Inicio Modal -->
    <div
      class="modal fade"
      id="user-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="roduct-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Registro de Usuarios</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">

            <div class="credenciales" v-if="$userIsAdmin()">
              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label for>Usuario</label>
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label for>Clave</label>
                    <input type="text" v-model="password" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label>Rol</label>
                    <select v-model="role" class="form-control">
                      <option :value="$constants.userRoles.ADMIN">Administrador</option>
                      <option :value="$constants.userRoles.COMERCE">Supervisor</option>
                      <option :value="$constants.userRoles.DELIVERY">Repartidor</option>
                    </select>
                  </div> 
                </div>
                <div class="col-sm-6" v-show="role === $constants.userRoles.COMERCE || role === $constants.userRoles.DELIVERY">
                  <div class="form-group">
                    <label>Seleccione sucursales</label>
                    <ul class="list-group user-companies-list">
                      <li v-for="c in companies" 
                        @click="selectCompany(c)"
                        :value="c.id" 
                        :class="c.selected ? 'list-group-item bg-success' : 'list-group-item'" 
                        :key="c.id">
                        {{ c.name }}
                      </li>
                    </ul>
                  </div> 
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <div class="row" style="width:100%;">
              <div class="col-sm-2">
                <Loader v-if="saving" />
              </div>
              <div class="col-sm-10 text-right">
                <button class="btn btn-danger" :disabled="saving" @click="cleanUserFields()">
                  <i class="fa fa-ban"></i>
                  Cancelar
                </button>
                &nbsp;
                <button
                  class="btn btn-success"
                  :disabled="saving"
                  @click="saveUserData"
                >
                  <i class="fa fa-save"></i>
                  Guardar cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Final Modal -->

    <!-- Inicio Modal cambio clave -->
    <div
      class="modal fade"
      id="password-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="roduct-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Cambio de clave</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="credenciales" v-if="$userIsAdmin()">
              <div class="row">
                <div class="col-sm-6">
                  <p>
                    <b>Usuario:</b>
                    {{ currentUser.name }}
                  </p>
                  <p>
                    <b>Correo:</b>
                    {{ currentUser.id }}
                  </p>
                  <div class="form-group">
                    <label for>Nueva Clave</label>
                    <input type="text" v-model="newPassword" maxlength="15" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="row" style="width:100%;">
              <div class="col-sm-2">
                <Loader v-if="saving" />
              </div>
              <div class="col-sm-10 text-right">
                <button class="btn btn-danger" :disabled="saving" @click="closePasswordModal()">
                  <i class="fa fa-ban"></i>
                  Cancelar
                </button>
                &nbsp;
                <button
                  class="btn btn-success"
                  :disabled="saving"
                  v-on:click="changePassword()"
                >
                  <i class="fa fa-save"></i>
                  Guardar cambios
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Final Modal -->
    

  </div>
</template>

<script>
import BreadCrumbs from '../components/Breadcrumbs'
import Loader from '../components/Loader'
import { UserService } from '../../services/UserService';
import { BranchOfficeService } from '../../services/BranchOfficeService';

export default {
  name: 'AdminUsers',
  components: { BreadCrumbs,Loader },
  data:function(){
    return {
      users: [],
      loading: false,
      email: "",
      password: "",
      name: "",
      role: '',
      loaders: {
        list: false,
      },
      inRequest: false,
      newUserIsNotAutenticated: true,
      modalOptions: {
        keyboard: false,
        backdrop: false,
      },
      thereAreUsers: true,
      companyPermissions: [],
      newPassword: "",
      currentUser: {
        id: "",
        name: "",
        email: "",
        uid: "",
      },
      saving: false,
      branchOfficeService: new BranchOfficeService(),
      companies: [],
      userCompany: '',
      userService: new UserService()
    }
  },
  methods: {
    selectCompany(company){
      company.selected = !company.selected;
    },
    async getUsers(){
      this.loading = true;
      const res = await this.userService.getAdminUsers();
      if(res.ok){
        this.users = res.data;
      }else{
        this.$helpers.message('Error', res.message, 'error');
      }
      this.loading = false;
    },
    closePasswordModal() {
      this.newPassword = "";
      this.currentUser = {
        id: "",
        name: "",
        email: "",
      };
      $("#password-modal").modal("hide");
    },
    async changePassword() {
      if (this.newPassword.length < 6) {
        this.$helpers.toast(
          "La clave debe tener minimo 6 caracteres.",
          "warning"
        );
        return;
      }
      this.newPassword = this.newPassword.trim();
      this.saving = true;

      try {
        const res = await this.userService.changeAdminUserPassword(
          this.currentUser.uid,
          this.newPassword
        );        
        if(res.ok){
          this.$helpers.toast("Clave actualizada!");
          this.closePasswordModal();
        }else{
          this.$helpers.message("Error", res.message, "error");
        }

      } catch (e) {
        this.$helpers.message("Error", "Error del servidor", "error");
        console.log("ERR: ", e);
      }
      this.saving = false;
    },
    openPasswordChangeModal(user) {
      this.currentUser = user;
      $("#password-modal").modal(this.modalOptions);
    },
    deleteUser: function (user) {
      if (user.loading || this.loading) return false;
      this.$helpers.confirm("Estas seguro?").then(async (ok) => {
        if (ok) {
          user.loading = true;
          try {
            await this.userService.deleteAdminUser(user.id, user.uid);
            this.users = this.users.filter((u) => u.id != user.id);
            this.$helpers.toast("Usuario eliminado!");
            user.loading = false;
          } catch (e) {
            this.$helpers.toast("Error del servidor", "error");
            console.log("ERR: ", e);
            user.loading = false;
          }
        }
      });
    },
    saveUserData: async function () {
      if (this.name.length < 5) {
        this.$helpers.toast("El nombre no es valido", "error");
        return false;
      }
      if (this.password.length < 5) {
        this.$helpers.toast("La clave es muy corta", "error");
        return false;
      }
      const hasNoCompany = this.selectedCompanies.length === 0;
      if (this.role !== this.$constants.userRoles.ADMIN && hasNoCompany) {
        this.$helpers.toast("Debes seleccionar almenos 1 compañía", "error");
        return false;
      }

      const isComerceAndHasNoCompany = this.role === this.$constants.userRoles.COMERCE && this.companies.filter(x => x.selected).length === 0;
      if (isComerceAndHasNoCompany) {
        this.$helpers.toast("Debes seleccionar almenos 1 compañía", "error");
        return false;
      }
      this.saving = true;
      const userCompanies = Array.from(new Set(this.selectedCompanies.map(x => x.companyId)));
      try {
        const name = this.name.trim().toLowerCase();
        const resp = await this.userService.createAdminUser(
          userCompanies,
          name,
          this.password.trim(),
          this.role
        );
        if(resp.data.ok){
          this.$helpers.toast("Usuario creado!");
          this.cleanUserFields();
          this.getUsers();
        }else{
          this.$helpers.message("Error", resp.data.message, "error");
        }
      } catch (e) {
        this.$helpers.toast("Error del servidor", e.message);
        console.log("ERR: ", e);
      }
      this.saving = false;
    },
    cleanUserFields: function () {
      this.name = "";
      this.email = "";
      this.password = "";
      this.newUserIsNotAutenticated = false;
      this.companies.forEach(x => x.selected = false);
      this.closeUserModal();
    },
    openModal: function () {
      this.cleanUserFields();
      $("#user-modal").modal(this.modalOptions);
    },
    closeUserModal: function () {
      $("#user-modal").modal("hide");
    },
  },
  computed: {
    selectedCompanies(){
      return this.companies.filter(x => x.selected);
    }
  },
  beforeMount: async function() {
    const res = await this.branchOfficeService.getBranchOffices();
    if(res.ok){
      res.branchOffices.forEach(x => x['selected'] = false);
      this.companies = res.branchOffices;
      this.getUsers();
    }else{
      this.$helpers.message("Error", res.message, "error");
    }
  }
}
</script>

<style scoped>
tbody td{
  font-weight: 400;
}
.table-wraper{
  overflow-y: auto;
  max-height: 60vh;
}
.user-companies-list{
  max-height: 196px;
  overflow-y: auto;
}
</style>